import { CartItem } from '@/types/cart.types';
import { ProcedureTypeEnum } from '@/types/enums/procedure-type.enum';

export function getDuplicatedCartItemIds(items: CartItem[]): ReadonlySet<string> {
  const idsByProcedure = new Map<string, string[]>();

  items.forEach((item) => {
    if (item.procedure.type === ProcedureTypeEnum.LABORATORY) {
      return;
    }

    const cartItemIds = idsByProcedure.get(item.procedure.id) ?? [];

    cartItemIds.push(item.id);
    idsByProcedure.set(item.procedure.id, cartItemIds);
  });

  const duplicatedIds = new Set<string>();

  idsByProcedure.forEach((cartItemIds) => {
    if (cartItemIds.length > 1) {
      cartItemIds.forEach((cartItemId) => duplicatedIds.add(cartItemId));
    }
  });

  return duplicatedIds;
}
